/**
 * sessionStorage key used to hand the impersonation custom token from the
 * synchronous capture in `main.ts` (before the router runs) to the lazily
 * loaded ImpersonateComponent.
 */
export const IMPERSONATION_TOKEN_KEY = 'crewdle.impersonationToken';

/**
 * sessionStorage key for the landing path the partner console asked for
 * (`/impersonate?next=/o/{orgId}/...#token=…`), captured alongside the token.
 * Honoured only inside the impersonated org (see impersonationLanding).
 */
export const IMPERSONATION_NEXT_KEY = 'crewdle.impersonationNext';
